import * as classNames from "classnames";
import * as React from "react";
import { withTheme } from "../../../../common/withTheme";

export type RadioButtonProps = {
    blockButton: boolean,
    checked: boolean,
    disabled: boolean,
    divClassName: string,
    id: string,
    inputClassName: string,
    label: string,
    labelClassName: string,
    largeButton: boolean,
    name: string,
    readOnly: boolean,
    value: string | number | string[],
    theme?: string
}

export type RadioButtonActions = {
    onBlur(event: React.FocusEvent<HTMLInputElement>): void,
    onChange(event: React.ChangeEvent<HTMLInputElement>): void,
    onFocus(event: React.FocusEvent<HTMLInputElement>): void
};

export type RadioButtonPropsAndActions = RadioButtonProps & RadioButtonActions;

class RadioButton extends React.PureComponent<RadioButtonPropsAndActions, any> {
    render() {
        return (
            <div
                className={classNames(this.props.theme, this.props.divClassName)}
            >
                <input
                    type="radio"
                    name={this.props.name}
                    id={this.props.id}
                    value={this.props.value}
                    checked={this.props.checked}
                    readOnly={this.props.readOnly}
                    disabled={this.props.disabled}
                    className={classNames(this.props.theme, this.props.inputClassName)}
                    onBlur={this.props.onBlur}
                    onChange={this.props.onChange}
                    onFocus={this.props.onFocus}
                />
                <label
                    className={classNames(this.props.theme, this.props.labelClassName)}
                    htmlFor={this.props.id}
                >
                    {this.props.label}
                </label>
            </div>
        );
    }
}

export default withTheme<RadioButtonPropsAndActions>(RadioButton);
